import React, { useEffect, useRef } from "react"

import CovidBanner from "../components/covid_banner"
import Footer from "../components/footer"

import logo_icon from "../assets/images/logo_simple.svg"

function Layout({ children }) {
  const preload_element = useRef(null),
    header_banner_element = useRef(null),
    nav_menu_button = useRef(null),
    toggle_menu = e => {
      e.preventDefault()

      if (preload_element.current.classList.contains("is-menu-visible")) {
        preload_element.current.classList.remove("is-menu-visible")
      } else {
        preload_element.current.classList.add("is-menu-visible")
      }
    },
    hide_menu = e => {
      e.preventDefault()
      preload_element.current.classList.remove("is-menu-visible")
    }

  // When loading a new view scroll to the top of the page
  useEffect(() => {
    window.scrollTo(0, 0)

    window.setTimeout(function () {
      preload_element.current.classList.remove("is-preload")
    }, 100)

    const handle_scroll = () => {
      const alt_exists = header_banner_element.current.classList.contains("alt")
      console.log({
        alt_exists,
        pageYOffset: window.pageYOffset,
      })
      if (window.pageYOffset > 600 && alt_exists) {
        header_banner_element.current.classList.remove("alt")
      } else if (window.pageYOffset <= 600 && !alt_exists) {
        header_banner_element.current.classList.add("alt")
      }
    }

    window.addEventListener("scroll", handle_scroll, { passive: true })
  }, [])

  return (
    <div ref={preload_element} className="is-preload" id="real-body">
      <div id="page-wrapper">
        <div id="header">
          <CovidBanner></CovidBanner>

          {/* header banner */}
          <header id="header-menu" className="alt" ref={header_banner_element}>
            <h1>
              <a href="/">
                <span>
                  <img src={logo_icon} alt="" />
                </span>
              </a>
            </h1>

            <nav
              ref={nav_menu_button}
              id="nav-menu-button"
              onClick={toggle_menu}
            >
              <a href="#menu">Menu</a>
            </nav>
          </header>
        </div>

        {children}

        <Footer></Footer>
      </div>

      {/* nav menu */}
      <nav id="menu">
        <div id="menu-background" onClick={hide_menu}></div>
        <div className="inner">
          <h2>Menu</h2>
          <ul className="links">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="/about">About Me</a>
            </li>
            <li>
              <a href="/our-journey">Our Journey</a>
            </li>
            <li>
              <a href="/modalities">Modalities</a>
            </li>
            <li>
              <a href="/services">My Services</a>
            </li>
            <li>
              <a href="/fees-policies">Fees and Policies</a>
            </li>
            {/* <li>
            <a href="link-resource">Links and Resources</a>
          </li>
          <li>
            <a href="workshops">Workshops</a>
          </li>
          <li>
            <a href="careers">Careers</a>
          </li> */}
            <li>
              <a href="/contact-us">Contact Me</a>
            </li>
          </ul>
          <a onClick={hide_menu} href="#" className="close">
            Close
          </a>
        </div>
      </nav>
    </div>
  )
}

export default Layout
